<mat-card class="delivery-card" [ngClass]="'class'+(order.id%4).toString()" appearance="outlined">
    <mat-card-header [ngClass]="'class'+(order.id%4).toString()">
        <mat-card-title class="titleCardLivraison">
           {{order.id}}&nbsp;{{ order.lnk_customer.firstname }}&nbsp;{{ order.lnk_customer.name }}
           <!-- {{ order.lnk_customer.firstname }}&nbsp;{{ order.lnk_customer.name }} -->
        </mat-card-title>
        <mat-card-subtitle>
            <div class="flexrow " >
                <!-- <div>{{ eval( order.lnk_customer.addresses.find( (adr) =>( adr.id === order.addr_deliv ) ).city ) }}</div> -->
                <div class="cityInCardLiv">{{ deliveryCity(order) }}</div>
                <!-- <div>{{  order.lnk_customer.addresses[0].city  }}</div> -->
                <!-- <div>{{  order.lnk_customer.addresses[0].city  }}</div> -->
                <div class="horaireCardLiv">{{ deliveryOpAndSlot$ | async }}</div>
            </div>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div>{{ deliveryOpAndSlot$ | async | json }}</div>
        @for (line of order.lines; track line.id) {
            <div>{{line.qty}}&nbsp;x&nbsp;{{line.product_name}}</div>
        }
    </mat-card-content>
</mat-card>
